module.exports = __webpack_public_path__ + "static/media/sleigh.7f2ca5c3.svg";